import { render, staticRenderFns } from "./ProductTaxesEditFostplus.vue?vue&type=template&id=3fcc0520&scoped=true"
import script from "./ProductTaxesEditFostplus.vue?vue&type=script&lang=ts"
export * from "./ProductTaxesEditFostplus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcc0520",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fcc0520')) {
      api.createRecord('3fcc0520', component.options)
    } else {
      api.reload('3fcc0520', component.options)
    }
    module.hot.accept("./ProductTaxesEditFostplus.vue?vue&type=template&id=3fcc0520&scoped=true", function () {
      api.rerender('3fcc0520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ProductTaxesEditFostplus.vue"
export default component.exports